import { useEffect, useState } from "react";
import sanityClient from "../client.js"
import { Link } from "react-router-dom";

export default function Wine () {
   
    const [wineData, setWine] = useState(null);

    useEffect(() => {
        sanityClient
            .fetch(`*
            `)
            .then((data) => setWine(data))
            .catch(console.error)
    }, [])
    return (
        <main className="bg-green-100 min-h-screen p-12">
            <section className="container mx-auto">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {wineData && wineData.map((wine,index)  => (
                    <article>
                        <span>
                            <h3>{wine.name}</h3>
                        </span>
                    </article>
                    ))}
                </div>
            </section>
        </main>
    )
}